<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <h4 class="page-title">Dashboard</h4>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 col-xl-4">
                <router-link :to="{name: 'dashboardTraineeCompletedList'}" tag="a" >
                    <div class="p-2 text-center card-box">
                        <h3>
                            <span v-if="completedTraineeCount !== 0">{{ completedTraineeCount }} 
                            </span>
                            <span v-else>0</span>
                        </h3>
                        <p class="text-muted font-15 mb-0">
                            Total Trainee Completed Training
                            <i id="tooltip-completed-trainee-count" class="fe-info" style="font-size: 13px;"></i>
                            <b-tooltip placement='topright' target="tooltip-completed-trainee-count" triggers="hover">
                                প্রশিক্ষণ শেষ করেছে সেসকল শিক্ষার্থীদের সংখ্যা 
                            </b-tooltip>
                        </p>
                    </div>
                </router-link>
            </div>
            <div class="col-md-6 col-xl-4">
                <router-link :to="{name: 'dashboardTraineeOngoingList'}" tag="a" >
                    <div class="p-2 text-center card-box">
                        <h3><span><span
                                v-if="ongoingTraineeCount !== 0">{{ ongoingTraineeCount }}</span><span v-else>0</span></span></h3>
                        <p class="text-muted font-15 mb-0">Total Trainee Ongoing Training
                            <i id="tooltip-ongoing-trainee-count" class="fe-info" style="font-size: 13px;"></i>
                            <b-tooltip placement='top' target="tooltip-ongoing-trainee-count" triggers="hover">
                                চলমান প্রশিক্ষণে শিক্ষার্থীদের সংখ্যা 
                            </b-tooltip>
                        </p>
                    </div>
                </router-link>
            </div>
            <div class="col-md-6 col-xl-4">
                <router-link :to="{name: 'dashboardCompletedBatchList'}" tag="a" >
                    <div class="p-2 text-center card-box">
                        <h3><span><span
                                v-if="completedBatchCount !== 0">{{ completedBatchCount }}</span><span v-else>0</span></span></h3>
                        <p class="text-muted font-15 mb-0">Total Completed Batch
                            <i id="tooltip-completed-batch-count" class="fe-info" style="font-size: 13px;"></i>
                            <b-tooltip placement='topleft' target="tooltip-completed-batch-count" triggers="hover">
                                ব্যাচ শেষ হয়েছে
                            </b-tooltip>
                        </p>
                    </div>
                </router-link>
            </div>
            <div class="col-md-6 col-xl-4">
                <router-link :to="{name: 'dashboardOngoingBatchList'}" tag="a" >
                    <div class="p-2 text-center card-box">
                        <h3><span><span v-if="ongoingBatchCount !== 0">{{ ongoingBatchCount }}</span><span v-else>0</span></span>
                        </h3>
                        <p class="text-muted font-15 mb-0">Total Ongoing Batch
                            <i id="tooltip-ongoing-batch-count" class="fe-info" style="font-size: 13px;"></i>
                            <b-tooltip placement='topright' target="tooltip-ongoing-batch-count" triggers="hover">
                                চলমান ব্যাচের সংখ্যা
                            </b-tooltip>
                        </p>
                    </div>
                </router-link>
            </div>
            <div class="col-md-6 col-xl-4">
                <router-link to="/dashboard/trainees/gender/1" tag="a" >
                    <div class="p-2 text-center card-box">
                        <h3><span><span v-if="traineeMaleCount !== 0">{{ traineeMaleCount }}</span><span v-else>0</span></span>
                        </h3>
                        <p class="text-muted font-15 mb-0">Total Male Trainee
                            <i id="tooltip-trainee-male-count" class="fe-info" style="font-size: 13px;"></i>
                            <b-tooltip placement='top' target="tooltip-trainee-male-count" triggers="hover">
                                মোট পুরুষ শিক্ষার্থী 
                            </b-tooltip>
                        </p>
                    </div>
                </router-link>
            </div>
            <div class="col-md-6 col-xl-4">
                <router-link to="/dashboard/trainees/gender/2" tag="a" >
                    <div class="p-2 text-center card-box">
                        <h3><span><span v-if="traineeFemaleCount !== 0">{{ traineeFemaleCount }}</span><span v-else>0</span></span>
                        </h3>
                        <p class="text-muted font-15 mb-0">Total Female Trainee
                            <i id="tooltip-trainee-female-count" class="fe-info" style="font-size: 13px;"></i>
                            <b-tooltip placement='topleft' target="tooltip-trainee-female-count" triggers="hover">
                                মোট নারী শিক্ষার্থী 
                            </b-tooltip>
                        </p>
                    </div>
                </router-link>
            </div>
        </div>
        <!-- <div class="row">-->
        <!--      <div class="col-md-6 col-xl-4">-->
        <!--        <div class="widget-rounded-circle card-box">-->
        <!--          <div class="row">-->
        <!--            <div class="col-3">-->
        <!--              <div class="avatar-lg rounded-circle bg-soft-primary border-primary border">-->
        <!--                <i class="fe-check font-22 avatar-title text-primary"></i>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-9">-->
        <!--              <div class="text-right">-->
        <!--                <h3 class="text-dark mt-1"><span><span>{{ completedTraineeCount }}</span></span></h3>-->
        <!--                <p class="text-muted mb-1 text-truncate">Total Trainee Completed Training</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--      <div class="col-md-6 col-xl-4">-->
        <!--        <div class="widget-rounded-circle card-box">-->
        <!--          <div class="row">-->
        <!--            <div class="col-3">-->
        <!--              <div class="avatar-lg rounded-circle bg-soft-warning border-warning border">-->
        <!--                <i class="fe-github font-22 avatar-title text-warning"></i>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-9">-->
        <!--              <div class="text-right">-->
        <!--                <h3 class="text-dark mt-1"><span><span>{{ ongoingTraineeCount }}</span></span></h3>-->
        <!--                <p class="text-muted mb-1 text-truncate">Total Trainee Ongoing Training</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--      <div class="col-md-6 col-xl-4">-->
        <!--        <div class="widget-rounded-circle card-box">-->
        <!--          <div class="row">-->
        <!--            <div class="col-3">-->
        <!--              <div class="avatar-lg rounded-circle bg-soft-info border-info border">-->
        <!--                <i class="fe-check font-22 avatar-title text-info"></i>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-9">-->
        <!--              <div class="text-right">-->
        <!--                <h3 class="text-dark mt-1"><span><span>{{ completedBatchCount }}</span></span></h3>-->
        <!--                <p class="text-muted mb-1 text-truncate">Total Completed Batch</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--      <div class="col-md-6 col-xl-4">-->
        <!--        <div class="widget-rounded-circle card-box">-->
        <!--          <div class="row">-->
        <!--            <div class="col-3">-->
        <!--              <div class="avatar-lg rounded-circle bg-soft-primary border-primary border">-->
        <!--                <i class="fe-github font-22 avatar-title text-primary"></i>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-9">-->
        <!--              <div class="text-right">-->
        <!--                <h3 class="text-dark mt-1"><span><span>{{ ongoingBatchCount }}</span></span></h3>-->
        <!--                <p class="text-muted mb-1 text-truncate">Total Ongoing Batch</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--      <div class="col-md-6 col-xl-4">-->
        <!--        <div class="widget-rounded-circle card-box">-->
        <!--          <div class="row">-->
        <!--            <div class="col-3">-->
        <!--              <div class="avatar-lg rounded-circle bg-soft-warning border-warning border">-->
        <!--                <i class="fe-users font-22 avatar-title text-warning"></i>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-9">-->
        <!--              <div class="text-right">-->
        <!--                <h3 class="text-dark mt-1"><span><span>{{ traineeMaleCount }}</span></span></h3>-->
        <!--                <p class="text-muted mb-1 text-truncate">Total Male Trainee</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--      <div class="col-md-6 col-xl-4">-->
        <!--        <div class="widget-rounded-circle card-box">-->
        <!--          <div class="row">-->
        <!--            <div class="col-3">-->
        <!--              <div class="avatar-lg rounded-circle bg-soft-info border-info border">-->
        <!--                <i class="fe-users font-22 avatar-title text-info"></i>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="col-9">-->
        <!--              <div class="text-right">-->
        <!--                <h3 class="text-dark mt-1"><span><span>{{ traineeFemaleCount }}</span></span></h3>-->
        <!--                <p class="text-muted mb-1 text-truncate">Total Female Trainee</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--    </div>-->
        <div class="row">
            <div class="col-md-6 col-sm-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-4">Mouza Chart 
                            <i id="tooltip-mouza-chart" class="fe-info" style="font-size: 13px; cursor: pointer;"></i>
                            <b-tooltip placement='topright' target="tooltip-mouza-chart" triggers="hover">
                                মৌজা ভিত্তিক শিক্ষার্থীদের সংখ্যার তালিকা
                            </b-tooltip>
                        </h4>
                        <!-- Bar Chart -->
                        <MouzaChart :height="350"/>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-4">Ongoing and Completed Training Chart in Mouza
                            <i id="tooltip-MouzaTraineeTrainingChart" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='top' target="tooltip-MouzaTraineeTrainingChart" triggers="hover">
                                মৌজা ভিত্তিক চলমান ও শেষ হয়েছে এরূপ প্রশিক্ষণের তালিকা
                            </b-tooltip>
                        </h4>
                        <!-- Bar Chart -->
                        <MouzaTraineeTrainingChart :height="350"/>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-4">Male and Female Trainee Chart in Mouza
                            <i id="tooltip-MouzaTraineeMaleFemaleChart" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='topleft' target="tooltip-MouzaTraineeMaleFemaleChart" triggers="hover">
                                মৌজা ভিত্তিক পুরুষ ও নারীদের তালিকা
                            </b-tooltip>
                        </h4>
                        <!-- Bar Chart -->
                        <MouzaTraineeMaleFemaleChart :height="350"/>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-sm-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-4">Union Chart
                            <i id="tooltip-UnionChart" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='topright' target="tooltip-UnionChart" triggers="hover">
                               ইউনিয়ন ভিত্তিক শিক্ষার্থীদের সংখ্যার তালিকা
                            </b-tooltip>
                        </h4>
                        <!-- Bar Chart -->
                        <UnionChart :height="350"/>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-4">Ongoing and Completed Training Chart in Union
                            <i id="tooltip-UnionTraineeTrainingChart" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='top' target="tooltip-UnionTraineeTrainingChart" triggers="hover">
                                ইউনিয়ন ভিত্তিক চলমান ও শেষ হয়েছে এরূপ প্রশিক্ষণের তালিকা
                            </b-tooltip>
                        </h4>
                        <!-- Bar Chart -->
                        <UnionTraineeTrainingChart :height="350"/>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-4">Male and Female Trainee Chart in Union
                            <i id="tooltip-UnionTraineeMaleFemaleChart" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='topleft' target="tooltip-UnionTraineeMaleFemaleChart" triggers="hover">
                                ইউনিয়ন ভিত্তিক পুরুষ ও নারীদের তালিকা
                            </b-tooltip>
                        </h4>
                        <!-- Bar Chart -->
                        <UnionTraineeMaleFemaleChart :height="350"/>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-4">Education Chart
                            <i id="tooltip-EducationChart" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='topright' target="tooltip-EducationChart" triggers="hover">
                                শ্রেণী ভিত্তিক শিক্ষার্থীদের শিক্ষা তালিকা
                            </b-tooltip>
                        </h4>
                        <!-- Bar Chart -->
                        <EducationChart :height="350"/>
                    </div>
                </div>
            </div>
<!--            <div class="col-lg-6">-->
<!--                <div class="card">-->
<!--                    <div class="card-body">-->
<!--                        <h4 class="header-title mb-4">Age Chart</h4>-->
<!--                        &lt;!&ndash; Bar Chart &ndash;&gt;-->
<!--                        <AgeChart :height="350"/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-2">Trainee Monthly Training Chart
                            <i id="tooltip-TraineeMonthlyTrainingChart" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='topleft' target="tooltip-TraineeMonthlyTrainingChart" triggers="hover">
                                কন মাসে কতজন শিক্ষার্থী প্রশিক্ষণ নিয়েছে তার তালিকা
                            </b-tooltip>
                        </h4>
                        <div class="row mb-3">
                            <div class="col-lg-12">
                                <div class="form-row">
                                    <div class="col-md-12">
                                        <select v-model="filterYear" @change="MonthlyChartFilter($event)" name="filterYear" id="filterYear" class="form-control form-control-sm">
                                            <option value="2018">2018</option>
                                            <option value="2019">2019</option>
                                            <option value="2020">2020</option>
                                            <option value="2021">2021</option>
                                            <option value="2022">2022</option>
                                            <option value="2023">2023</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- Bar Chart -->
                        <TraineeMonthlyTrainingChart :filterYear="filterYear" :height="520" ref="form"/>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">
                        <h4 class="header-title mb-4">Trainee Trade Chart
                            <i id="tooltip-TradeChart" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='topright' target="tooltip-TradeChart" triggers="hover">
                                কন ট্রেডে কতজন শিক্ষার্থী প্রশিক্ষণ নিয়েছে তার তালিকা
                            </b-tooltip>
                        </h4>
                        <!-- Bar Chart -->
                        <TradeChart :height="410"/>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">
                        <h5 class="header-title mb-0">Driving License Chart
                            <i id="tooltip-DrivingLicenseChart" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='topleft' target="tooltip-DrivingLicenseChart" triggers="hover">
                                ড্রাইভিং শিখতেছে এরূপ শিক্ষার্থীদের ৩টি ধাপের সংখ্যার তালিকা
                            </b-tooltip>
                        </h5>
                        <!-- Bar Chart -->
                        <DrivingLicenseChart :height="280"/>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">
                        <h5 class="header-title mb-0">Monthly Income After Training
                            <i id="tooltip-MonthlyIncomeAfterTraining" class="fe-info" style="font-size: 13px;cursor: pointer;"></i>
                            <b-tooltip placement='topright' target="tooltip-MonthlyIncomeAfterTraining" triggers="hover">
                                প্রশিক্ষণ শেষে শিক্ষার্থীদের মাসিক উপার্জনের তালিকা
                            </b-tooltip>
                        </h5>
                        <!-- Bar Chart -->
                        <MonthlyIncomeAfterTraining :height="280"/>
                    </div>
                </div>
            </div>

        </div>
    </Layout>
</template>
<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import http from "@state/http";
    import store from "../../state/store";

    import MouzaChart from './dashboard/chart/MouzaChart'
    import UnionChart from './dashboard/chart/UnionChart'
    import EducationChart from './dashboard/chart/EducationChart'
    import AgeChart from './dashboard/chart/AgeChart'
    import MouzaTraineeTrainingChart from './dashboard/chart/MouzaTraineeTrainingChart'
    import MouzaTraineeMaleFemaleChart from './dashboard/chart/MouzaTraineeMaleFemaleChart'
    import UnionTraineeTrainingChart from './dashboard/chart/UnionTraineeTrainingChart'
    import UnionTraineeMaleFemaleChart from './dashboard/chart/UnionTraineeMaleFemaleChart'
    import TraineeMonthlyTrainingChart from './dashboard/chart/TraineeMonthlyTrainingChart'
    import TradeChart from './dashboard/chart/TradeChart'
    import DrivingLicenseChart from './dashboard/chart/DrivingLicenseChart.vue'
    import MonthlyIncomeAfterTraining from './dashboard/chart/MonthlyIncomeAfterTraining.vue'

    export default {
        page: {
            title: "Dashboard",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {
            Layout,
            MouzaChart,
            UnionChart,
            EducationChart,
            // AgeChart,
            MouzaTraineeTrainingChart,
            MouzaTraineeMaleFemaleChart,
            UnionTraineeTrainingChart,
            UnionTraineeMaleFemaleChart,
            TraineeMonthlyTrainingChart,
            TradeChart,
            DrivingLicenseChart,
            MonthlyIncomeAfterTraining
        },
        data() {
            return {
                title: "Dashboard",
                items: [
                    {
                        text: "DORP",
                        href: "/"
                    },
                    {
                        text: "Dashboard",
                        active: true
                    }
                ],
                completedBatchCount: "",
                ongoingBatchCount: "",
                completedTraineeCount: "",
                ongoingTraineeCount: "",
                traineeMaleCount: "",
                traineeFemaleCount: "",
                filterYear: "2019",
                endVal: 0
            };
        },
        mounted() {
            if (store.getters['auth/loggedIn']) {
                this.count();
            }
        },
        methods: {
            count() {
                let tradeId = this.$route.params.trade_id;

                if (tradeId) {
                     http.get("api/count/" + tradeId)
                        .then(response => {
                            this.completedBatchCount = response.data.completedBatchCount;
                            this.ongoingBatchCount = response.data.ongoingBatchCount;
                            this.completedTraineeCount = response.data.completedTraineeCount;
                            this.ongoingTraineeCount = response.data.ongoingTraineeCount;
                            this.traineeMaleCount = response.data.traineeMaleCount;
                            this.traineeFemaleCount = response.data.traineeFemaleCount;
                        })
                } else {
                     http.get("api/count")
                        .then(response => {
                            this.completedBatchCount = response.data.completedBatchCount;
                            this.ongoingBatchCount = response.data.ongoingBatchCount;
                            this.completedTraineeCount = response.data.completedTraineeCount;
                            this.ongoingTraineeCount = response.data.ongoingTraineeCount;
                            this.traineeMaleCount = response.data.traineeMaleCount;
                            this.traineeFemaleCount = response.data.traineeFemaleCount;
                        })
                }


            },
            async MonthlyChartFilter(event){
                this.filterYear = event.target.value
                await this.$refs.form.monthlyTraineeTrainingChart(this.filterYear)
            }
        },
    };
</script>
